export default "__VITE_ASSET__Ck2w4obv__"